export default __webpack_public_path__ + "static/media/connect.7dd67d37.png";